export const PROFILE = {
  name: "Kusum Shaikh",
  fullName: "Kulsum Bi Shaikh",
  role: "Football Coach",
  tagline: "Former National-Level Player · Football Coach",
  location: "Goa, India",
  summary:
    "Dedicated and passionate football coach with competitive playing experience in India. Proven ability to design and deliver high-impact training programs that maximise player potential and overall team performance. Skilled in talent evaluation, player development, and coaching-staff selection — committed to fostering a positive, growth-oriented environment that drives both individual and team success.",
  email: "kusumxec.99@gmail.com",
  social: "@kusum09",
  instagram: "https://instagram.com/kusum09",
  facebook: "https://facebook.com/kusum09",
  cvUrl: "/images/kusum-cv.pdf",
  photos: {
    portrait: "/images/kusum-portrait.jpg",
    hero: "/images/kusum-hero.jpg",
    action: "/images/kusum-action.jpg",
  },
};

export const STATS = [
  { value: 20, suffix: "", label: "Matches Unbeaten", context: "FC Tuem run to IWL2" },
  { value: 60, suffix: "%", label: "Performance Gain", context: "Team metrics improved" },
  { value: 10, suffix: "+", label: "Years Playing", context: "State-level career" },
  { value: 1, suffix: "st", label: "Female Coach", context: "Men's Goa Pro League" },
];

export const TIMELINE = [
  {
    year: "2025 — 26",
    role: "Head of Women's Football",
    org: "Sethu FC · Indian Women's League (IWL)",
    points: [
      "Developing the long-term vision & philosophy for the women's football department.",
      "Overseeing recruitment, retention and development across senior, youth & grassroots.",
      "Leading coaching, medical & support staff, budgets, logistics and match-day operations.",
    ],
  },
  {
    year: "2025",
    role: "Assistant Coach — Philippines U-17 Women",
    org: "AFC U-17 Qualifiers · Tajikistan",
    points: [
      "Helped guide the Philippines U-17 Women to qualify for the AFC U-17 Asian Cup China 2026.",
      "Led technical planning, training sessions and in-match tactical execution.",
      "Strong international exposure working with a multicultural squad and staff.",
    ],
  },
  {
    year: "2025",
    role: "Talent Scout — AIFF",
    org: "IWL 2, Goa",
    points: [
      "Appointed by AIFF as a Talent Scout for IWL 2 in Goa.",
      "Identified top emerging players — including Fragrancy Riwan of Garhwal United.",
      "Scouted players who went on to earn their U-20 national-team debuts.",
    ],
  },
  {
    year: "2024 — 25",
    role: "Assistant Coach",
    org: "Odisha FC · Indian Women's League (IWL)",
    points: [
      "Designed & delivered high-intensity sessions to lift team performance.",
      "Developed set-piece routines and led pre-match warm-ups & strategy.",
      "Ran video-analysis sessions with individual & tactical feedback.",
    ],
  },
  {
    year: "2024 — 25",
    role: "Assistant Coach",
    org: "Geno FC · Goa Pro League (Men)",
    points: [
      "Became the FIRST female coach to lead a men's team in the Goa Pro League (6th place).",
      "Led the team as head coach in two matches — one win, one draw.",
      "Assisted recruitment, match strategy and player preparation.",
    ],
  },
  {
    year: "2023 — 24",
    role: "Head Coach",
    org: "FC Tuem · Vedanta Women's League",
    points: [
      "Led FC Tuem to the Goa Vedanta League title and IWL2 qualification.",
      "Improved team performance metrics by 60% through a bespoke training program.",
      "Unbeaten in 20 matches; mentored players later signed by Bengaluru FC & India U17/U20.",
    ],
  },
  {
    year: "2023",
    role: "Head Coach — U21",
    org: "Geno FC · Reliance Foundation Development League",
    points: [
      "Led Geno FC's U-21 men's side to 4 wins in 7, finishing 3rd in regional qualifiers.",
      "Scouted & developed players who progressed into the senior men's pro team.",
    ],
  },
];

export const CERTIFICATIONS = [
  { code: "AFC B", label: "AFC B Licence", year: "2024" },
  { code: "AFC C", label: "AFC C Licence", year: "2023" },
  { code: "AIFF D", label: "AIFF D Licence", year: "2023" },
];

export const HONOURS = [
  { year: "2023", title: "Vedanta Women's League — Winner", team: "FC Tuem (Senior Women)" },
  { year: "2022", title: "Vedanta Women's League — Winner", team: "Churchill Brothers (Senior Women)" },
  { year: "2021", title: "Vedanta Women's League — Runners-up", team: "FC Goa (Senior Women)" },
];

export const PLAYING = ["Goa State U-14", "Goa State U-17", "Goa State Senior Women"];

export const LANGUAGES = ["English", "Hindi", "Konkani", "Marathi"];

export const EDUCATION = [
  { degree: "M.Sc. Botany", school: "Goa University, Panaji", year: "2020" },
  { degree: "B.Sc. Botany", school: "Dhempe College of Arts & Science, Panaji", year: "2018" },
];

export const EXPERTISE = [
  "Talent Evaluation",
  "Player Development",
  "Tactical Execution",
  "Set-Piece Strategy",
  "Video Analysis",
  "Match Preparation",
  "Staff & Squad Management",
  "Grassroots to Elite Pathways",
];

export const NAV = [
  { id: "about", label: "About" },
  { id: "journey", label: "Journey" },
  { id: "impact", label: "Impact" },
  { id: "credentials", label: "Credentials" },
  { id: "contact", label: "Contact" },
];
